import { render, staticRenderFns } from "./RestaurantAmenities.vue?vue&type=template&id=0a76708e&scoped=true&"
import script from "./RestaurantAmenities.vue?vue&type=script&lang=js&"
export * from "./RestaurantAmenities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a76708e",
  null
  
)

export default component.exports